/**
 * Created by Jerker Nord on 2024-01-22.
 */
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../../core/winpresentation/SimplePresentationRunner";
import {Loner} from "../../../Loner";
import {LonerGameMode} from "../../../server/LonerGameMode";

export class LonerSSDShootPresentation implements SimplePresentation {

    private _controller:SimplePresentationRunnerController;

    public shouldRun():boolean {
        return true;
    }

    public start(controller:SimplePresentationRunnerController):void {
        this._controller = controller;
        this.complete();
        Loner.ssdMainView.playShootDuckTL(() => this.onShootComplete());
    }

    private onShootComplete():void {
        Loner.shootShootDuckResponsePresentation.shootingComplete = true;
        if(Loner.model.data.nextMode == LonerGameMode.NORMAL) {
            Loner.ssdOutroPresentation.shootingComplete = true;
        }
    }

    protected complete():void {
        this._controller.finish();
    }
}